import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'

const styles = theme => ({
  root: {
    fontFamily: '"Open Sans", sans-serif',
    fontWeight: 300,
    fontSize: 24 * 0.65,
    color: theme.palette.error.main,
  },
})

const OnboardingStepError = ({ classes, children }) => (
  <div className={classes.root}>
    { children }
  </div>
)

OnboardingStepError.propTypes = {
  classes: PropTypes.object.isRequired,
  children: PropTypes.any,
}

export default withStyles(styles)(OnboardingStepError)
